import * as React from 'react';

import { Field } from 'redux-form';

import FormControlLabel from '@material-ui/core/FormControlLabel';
import Radio from '@material-ui/core/Radio';
import { withStyles, createStyles, WithStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';

import type { JobFieldProps } from './job-field';

import { JobField } from './job-field';

import { RadioGroup } from '../../widgets/redux-form-fields/material-ui-wrappers';

const styles = () =>
  createStyles({
    formField: {
      width: '100%',
    },
  });

type InputProps = {
  job: Partial<Job>;
  isEditing?: boolean;
  change: Function;
};

type State = {
  applicantSharingScoreThreshold: string | null;
};

type Props = InputProps & JobFieldProps & WithStyles<typeof styles>;

const BEST_APPLICANT_THRESHOLD = '70';
const GOOD_APPLICANT_THRESHOLD = '50';
const MEETS_REQUIREMENTS_THRESHOLD = '0';

class JobFieldApplicantScoreThresholdComponent extends React.PureComponent<Props, State> {
  state = {
    applicantSharingScoreThreshold:
      String(this.props.job.applicantSharingScoreThreshold) || MEETS_REQUIREMENTS_THRESHOLD,
  };

  handleRadioChange = (_event: React.ChangeEvent<HTMLInputElement>, newValue?: string) => {
    this.props.change('applicantSharingScoreThreshold', String(newValue));
    this.setState({
      applicantSharingScoreThreshold: String(newValue),
    });
  };

  render() {
    const { classes, job } = this.props;
    const { classes: _, ...childrenProps } = this.props;
    // We shouldn't have to do it this way but for some reason redux-form doesn't like handling the initial checked value. If
    // some future person comes in here, please try and remove this
    const currValue =
      this.state.applicantSharingScoreThreshold || String(job.applicantSharingScoreThreshold);
    return (
      <div className={classes.formField}>
        <JobField
          {...childrenProps}
          title="Applicant Sharing"
          caption="This is the quality of applicant that we automatically share with you."
          editView={
            <Field
              id="applicant-sharing-score-threshold"
              name="applicantSharingScoreThreshold"
              component={RadioGroup}
              onChange={this.handleRadioChange}
            >
              <FormControlLabel
                value={MEETS_REQUIREMENTS_THRESHOLD}
                checked={currValue === MEETS_REQUIREMENTS_THRESHOLD}
                control={<Radio />}
                label="Share all applicants who meet the job requirements"
              />
              {String(job.applicantSharingScoreThreshold) === GOOD_APPLICANT_THRESHOLD && (
                <FormControlLabel
                  value={GOOD_APPLICANT_THRESHOLD}
                  disabled
                  checked={currValue === GOOD_APPLICANT_THRESHOLD}
                  control={<Radio />}
                  label="Share good applicants"
                />
              )}
              <FormControlLabel
                value={BEST_APPLICANT_THRESHOLD}
                checked={currValue === BEST_APPLICANT_THRESHOLD}
                control={<Radio />}
                label="Share only the best applicants"
              />
            </Field>
          }
          displayView={
            <Typography variant="body2">
              {currValue === MEETS_REQUIREMENTS_THRESHOLD
                ? 'Share all applicants who meet the job requirements'
                : currValue === BEST_APPLICANT_THRESHOLD
                ? 'Share only the best applicants'
                : 'Share good applicants'}
            </Typography>
          }
        />
      </div>
    );
  }
}

export const JobFieldApplicantScoreThreshold = withStyles(styles)(
  JobFieldApplicantScoreThresholdComponent,
);
